// extracted by mini-css-extract-plugin
export default {"videoList":"video-list__videoList--3dmzG"};
    if(module.hot) {
      // 1779972114745
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  